import {Navigate} from "react-router-dom"

export default function RequireAuth(props) {
    let auth = props.isLogin
    if (!auth) {
        return props.sso ? <Navigate to={props.sso.ssoUrl}/> : <Navigate to="/signin"/>
    }
    return props.children
}